// extracted by mini-css-extract-plugin
export var Digital = "featuredProject-module--Digital--3a402";
export var Fuel = "featuredProject-module--Fuel--86116";
export var Money = "featuredProject-module--Money--99914";
export var Time = "featuredProject-module--Time--2fb8c";
export var Trees = "featuredProject-module--Trees--5a951";
export var active = "featuredProject-module--active--9e6a7";
export var additionalInformation = "featuredProject-module--additionalInformation--a172e";
export var benefitContainer = "featuredProject-module--benefitContainer--875b7";
export var benefits = "featuredProject-module--benefits--1366b";
export var content = "featuredProject-module--content--15e3f";
export var contentContainer = "featuredProject-module--contentContainer--aa1aa";
export var contentSection = "featuredProject-module--contentSection--01c0f";
export var contributePartner = "featuredProject-module--contributePartner--774a4";
export var contributerLink = "featuredProject-module--contributerLink--4e1b7";
export var contributingPartners = "featuredProject-module--contributingPartners--426f2";
export var countries = "featuredProject-module--countries--8a132";
export var countryLink = "featuredProject-module--countryLink--ec76e";
export var countryList = "featuredProject-module--countryList--85b5f";
export var description = "featuredProject-module--description--6093a";
export var disclaimer = "featuredProject-module--disclaimer--53f32";
export var hero = "featuredProject-module--hero--a23b0";
export var image = "featuredProject-module--image--b4768";
export var imageContainer = "featuredProject-module--imageContainer--a942d";
export var informationList = "featuredProject-module--informationList--abfbd";
export var label = "featuredProject-module--label--81411";
export var leaderLink = "featuredProject-module--leaderLink--e3f4f";
export var listItem = "featuredProject-module--listItem--2cdb3";
export var mediaContainer = "featuredProject-module--mediaContainer--f708d";
export var partnerContainer = "featuredProject-module--partnerContainer--0306e";
export var starBackground = "featuredProject-module--starBackground--f9435";
export var timelineContainer = "featuredProject-module--timelineContainer--dc301";
export var timelineInfo = "featuredProject-module--timelineInfo--5c34d";